// Daily stats fetch
export const TARGET_DAILY_FETCH_REQUEST = 'TARGET_DAILY_FETCH_REQUEST';
export const TARGET_DAILY_FETCH_SUCCESS = 'TARGET_DAILY_FETCH_SUCCESS';
export const TARGET_DAILY_FETCH_FAILURE = 'TARGET_DAILY_FETCH_FAILURE';

// Range stats fetch (rolling / historical)
export const TARGET_RANGE_FETCH_REQUEST = 'TARGET_RANGE_FETCH_REQUEST';
export const TARGET_RANGE_FETCH_SUCCESS = 'TARGET_RANGE_FETCH_SUCCESS';
export const TARGET_RANGE_FETCH_FAILURE = 'TARGET_RANGE_FETCH_FAILURE';

// Weekly stats fetch
export const TARGET_WEEKLY_FETCH_REQUEST = 'TARGET_WEEKLY_FETCH_REQUEST';
export const TARGET_WEEKLY_FETCH_SUCCESS = 'TARGET_WEEKLY_FETCH_SUCCESS';
export const TARGET_WEEKLY_FETCH_FAILURE = 'TARGET_WEEKLY_FETCH_FAILURE';

// Weekly trend fetch (last N weeks for week-over-week chart)
export const TARGET_WEEKLY_TREND_REQUEST = 'TARGET_WEEKLY_TREND_REQUEST';
export const TARGET_WEEKLY_TREND_SUCCESS = 'TARGET_WEEKLY_TREND_SUCCESS';
export const TARGET_WEEKLY_TREND_FAILURE = 'TARGET_WEEKLY_TREND_FAILURE';

// Calendar-month report
export const TARGET_MONTHLY_FETCH_REQUEST = 'TARGET_MONTHLY_FETCH_REQUEST';
export const TARGET_MONTHLY_FETCH_SUCCESS = 'TARGET_MONTHLY_FETCH_SUCCESS';
export const TARGET_MONTHLY_FETCH_FAILURE = 'TARGET_MONTHLY_FETCH_FAILURE';

// Compact recent-performance report
export const TARGET_ROLLING_REQUEST = 'TARGET_ROLLING_REQUEST';
export const TARGET_ROLLING_SUCCESS = 'TARGET_ROLLING_SUCCESS';
export const TARGET_ROLLING_FAILURE = 'TARGET_ROLLING_FAILURE';
